import { render, staticRenderFns } from "./HtmlTextareaInput.vue?vue&type=template&id=5f219a46"
import script from "./HtmlTextareaInput.vue?vue&type=script&lang=ts"
export * from "./HtmlTextareaInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports